import { ExpandMore } from "@mui/icons-material";
import { AccordionSummary, Tooltip, Typography } from "@mui/material";

import FormatISODateTime from "../../../../../global/FormatISODateTime";
import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { ACTION_TYPE_MAPPING } from "../../utils/strings";

export default function CustomFollowUpHistoryAccordionSummary({ loading, data }) {
  const actionType = Number(data?.actionType);
  const actionTypeMap = ACTION_TYPE_MAPPING[Number(actionType)];
  const icon = actionTypeMap.icon;
  const iconColor = icon?.color;
  const iconSvg = icon?.label;
  const accessPath = actionTypeMap?.access;
  const resolvePath = (obj, path) =>
    String(path || "")
      .split(".")
      .filter(Boolean)
      .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  const accessObj = accessPath ? resolvePath(data, accessPath) : undefined;
  const nameFromAccess = accessObj?.name;
  const displayName = nameFromAccess;
  const tooltip = actionTypeMap?.label;
  const dueDate = FormatISODateTime(data?.dueDate);
  const relativeDueDate = data.relativeDueDate;

  return (
    <AccordionSummary
      expandIcon={
        <ExpandMore
          style={{
            color: HNSColors.primary[500],
          }}
        />
      }
    >
      <div className="flex w-full flex-col gap-2">
        <div className="flex w-full flex-row items-center gap-4">
          <div>
            <Tooltip title={tooltip || ""} arrow>
              <span style={{ display: "inline-flex", lineHeight: 0 }}>
                <Svg
                  name={iconSvg}
                  color={iconColor}
                  sx={{ height: "24px", width: "24px", fontWeight: "600" }}
                />
              </span>
            </Tooltip>
          </div>
          <Typography
            className="text-[16px] font-semibold"
            style={{ color: HNSColors.neutrals[100] }}
          >
            {displayName}
          </Typography>
        </div>
        <div className="">
          <Typography className="flex w-full flex-row items-center gap-1 text-[12px] font-medium">
            <div>
              <span className="font-semibold">DUE:&nbsp;</span>
              <span className="text-[12px]">{dueDate}</span>
            </div>
            <span className="text-[12px] italic">{`(${relativeDueDate})`}</span>
          </Typography>
        </div>
      </div>
    </AccordionSummary>
  );
}
